import { BaseEntity } from "@bndes/bndes-ux4/bndes-angular-utils";

export class EmpresasBloqueadas extends BaseEntity {
    listaCnpj : EmpresasBloqueadasCnpj;
}

export class EmpresasBloqueadasCnpj extends BaseEntity {
    cnpj1: string; 
    cnpj2: string;
    cnpj3: string;
    cnpj4: string;
    cnpj5: string;
    cnpj6: string;
    cnpj7: string;
    cnpj8: string;
    cnpj9: string;
    cnpj10: string;
}


export const consultaCNPJExemplo =
`
{
	"listaCnpj": {
		"cnpj1": "xxxxxxxx",
		"cnpj2": "xxxxxxxx",
		"cnpj3": "xxxxxxxx",
		"cnpj4": "xxxxxxxx",
		"cnpj5": "xxxxxxxx",
		"cnpj6": "xxxxxxxx",
		"cnpj7": "xxxxxxxx",
		"cnpj8": "xxxxxxxx",
		"cnpj9": "xxxxxxxx",
		"cnpj10": "xxxxxxxx"
	}
}
`;

